import { useCallback, useState } from 'react';

import Button from 'components/field/Button';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

const EditButton = ({ row, isRowEditing, setEditing, onRowEdit, onRowEditEnd }) => {
	const [loading, setLoading] = useState(false);
	const isMobile = useMediaQuery(Breakpoints.mobile);

	const enableEdit = useCallback((row) => {
		setEditing((prev) => [...prev, row.index]);
	}, []);

	const disableEdit = useCallback((row) => {
		setEditing((prev) => prev.filter((filter) => filter !== row.index));
	}, []);

	const handleButtonClick = useCallback(async () => {
		setLoading(true);

		if (isRowEditing) {
			if (onRowEditEnd) {
				const isSuccess = await onRowEditEnd(row);
				isSuccess && disableEdit(row);
			} else {
				disableEdit(row);
			}
		} else {
			if (onRowEdit) {
				const isSuccess = await onRowEdit(row);
				isSuccess && enableEdit(row);
			} else {
				enableEdit(row);
			}
		}

		if (isMobile && !row.getIsExpanded()) {
			row.toggleExpanded();
		}
		setLoading(false);
	}, [row, isRowEditing, onRowEdit, onRowEditEnd, isMobile, enableEdit, disableEdit]);

	return (
		<Button
			icon={isRowEditing ? faCheck : faEdit}
			onClick={handleButtonClick}
			loading={loading}
			variant="transparent"
			iconSize="medium"
			iconButton
		/>
	);
};

export default EditButton;
